var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8V6C14 4.89543 13.1046 4 12 4H5C3.89543 4 3 4.89543 3 6V18C3 19.1046 3.89543 20 5 20H12C13.1046 20 14 19.1046 14 18V16",
    stroke: "#4B465C",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8V6C14 4.89543 13.1046 4 12 4H5C3.89543 4 3 4.89543 3 6V18C3 19.1046 3.89543 20 5 20H12C13.1046 20 14 19.1046 14 18V16",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.125C6.51675 11.125 6.125 11.5168 6.125 12C6.125 12.4832 6.51675 12.875 7 12.875V11.125ZM21 12V12.875C21.3539 12.875 21.673 12.6618 21.8084 12.3348C21.9438 12.0079 21.869 11.6315 21.6187 11.3813L21 12ZM18.6187 8.38128C18.277 8.03957 17.723 8.03957 17.3813 8.38128C17.0396 8.72299 17.0396 9.27701 17.3813 9.61872L18.6187 8.38128ZM17.3813 14.3813C17.0396 14.723 17.0396 15.277 17.3813 15.6187C17.723 15.9604 18.277 15.9604 18.6187 15.6187L17.3813 14.3813ZM21.6187 12.6187C21.9604 12.277 21.9604 11.723 21.6187 11.3813C21.277 11.0396 20.723 11.0396 20.3813 11.3813L21.6187 12.6187ZM7 12.875H21V11.125H7V12.875ZM21.6187 11.3813L18.6187 8.38128L17.3813 9.61872L20.3813 12.6187L21.6187 11.3813ZM18.6187 15.6187L21.6187 12.6187L20.3813 11.3813L17.3813 14.3813L18.6187 15.6187Z",
    fill: "#4B465C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.125C6.51675 11.125 6.125 11.5168 6.125 12C6.125 12.4832 6.51675 12.875 7 12.875V11.125ZM21 12V12.875C21.3539 12.875 21.673 12.6618 21.8084 12.3348C21.9438 12.0079 21.869 11.6315 21.6187 11.3813L21 12ZM18.6187 8.38128C18.277 8.03957 17.723 8.03957 17.3813 8.38128C17.0396 8.72299 17.0396 9.27701 17.3813 9.61872L18.6187 8.38128ZM17.3813 14.3813C17.0396 14.723 17.0396 15.277 17.3813 15.6187C17.723 15.9604 18.277 15.9604 18.6187 15.6187L17.3813 14.3813ZM21.6187 12.6187C21.9604 12.277 21.9604 11.723 21.6187 11.3813C21.277 11.0396 20.723 11.0396 20.3813 11.3813L21.6187 12.6187ZM7 12.875H21V11.125H7V12.875ZM21.6187 11.3813L18.6187 8.38128L17.3813 9.61872L20.3813 12.6187L21.6187 11.3813ZM18.6187 15.6187L21.6187 12.6187L20.3813 11.3813L17.3813 14.3813L18.6187 15.6187Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.24a15e913234660f6a8aee186bf6c891.svg";
export { ForwardRef as ReactComponent };